import { render, staticRenderFns } from "./BrandCreateView.vue?vue&type=template&id=18ac753b"
import script from "./BrandCreateView.vue?vue&type=script&lang=js"
export * from "./BrandCreateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports